// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__2zT4-","title":"Rating_title__PoOba","card":"Rating_card__2LT0q"};